import { Menu } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import { NavLink } from './NavLink';
import { useState } from 'react';

export const MobileNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild className="md:hidden">
        <Button variant="ghost" size="icon" className="hover:bg-dark-bg-tertiary">
          <Menu className="w-6 h-6 text-dark-text-primary" />
        </Button>
      </SheetTrigger>

      <SheetContent side="left" className="bg-dark-bg-secondary border-dark-border-default">
        <SheetHeader>
          <SheetTitle className="text-dark-text-primary">Menu</SheetTitle>
        </SheetHeader>

        <nav className="flex flex-col gap-6 mt-8">
          <NavLink to="/" className="text-lg">
            Home
          </NavLink>
          <NavLink to="/shop" className="text-lg">
            Shop
          </NavLink>
          <NavLink to="/downloads" className="text-lg">
            Downloads
          </NavLink>
          <NavLink to="/about" className="text-lg">
            About
          </NavLink>
        </nav>
      </SheetContent>
    </Sheet>
  );
};
